__turbopack_context__.v({
  "desktopOnly": "ResponsiveOnly-module-scss-module__ounq1G__desktopOnly",
  "mobileOnly": "ResponsiveOnly-module-scss-module__ounq1G__mobileOnly",
});
